import { FC, useCallback, useEffect, useState } from "react"
import { FilterValues, TResource } from "widgets/mobileIndex/lib/hooks/useMobilePlace"
import { TableItem } from "./style";
import { Control, Controller } from "react-hook-form";

interface TableProps {
  item: TResource;
  isActive?: boolean;
  onClick: (item:TResource) => void;
  control: Control<FilterValues, any>;
}
export const Table: FC<TableProps> = ({
  item,
  isActive = false,
  onClick,
  control
}) => {
  const [ localIsActive, setLocalIsActive ] = useState<boolean>(isActive)
  const [ pen, setpen ] = useState<boolean>(false)

  const onTableClick = useCallback(() => {
    setLocalIsActive(!localIsActive);
    setpen(true);
    onClick(item);

    setTimeout(() => {
      setpen(false);
    }, 500);
  }, [setLocalIsActive, localIsActive, onClick, setpen, item])

  useEffect(()=>{
    setLocalIsActive(isActive);
  }, [isActive])

  return (
    <TableItem
      $active={localIsActive}
      $pen={pen}
      onClick={onTableClick}
    >
      <span>{item.name}</span>
      <Controller
        name="duration"
        control={control}
        render={({ field }) => (
          <><span>{field.value.label}</span></>
        )}
      />
    </TableItem>
  )
}